const defaultDateFormat = 'YYYY-MM-DD';

export default defaultDateFormat;
